import {
  Component,
  ViewChild,
  TemplateRef,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { MARKETDATA_COPYRIGHT_MESSAGE } from "src/app/common-constants";
import { Subscription } from "rxjs";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { ComparativeAnalysisService } from "./../comparative-analysis.service";
import {
  createTPRTabUserSettings,
  getMetaPayloadFromUrls,
  updateCustomTableSettings,
  updateCustomTableSettingsForTickers,
} from "src/app/comparative-analysis/comparative-analysis-utils";
import {
  faTimes,
  faCheck,
  faTimesCircle,
  faInfoCircle,
} from "@fortawesome/pro-solid-svg-icons";
import { updateColumnPickerData } from "src/app/tpr/tpr-utils";
import { getSelectedColumnPickerItemName } from "src/app/utils/common";
import { TPRDataService } from "src/app/tpr/tpr-data.service";
import { TAB_BE_MAPPING } from "../constants";
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";
import { ComparativeTickerModalComponent } from "../comparative-ticker-modal/comparative-ticker-modal.component";
import { NzModalService, NzModalRef } from "ng-zorro-antd/modal";
import { WatchlistService } from "src/app/watchlist/watchlist.service";
import { AddWatchlistData } from "src/app/store/actions/global.actions";
import { CompsDataService } from "src/app/comps-page/comps-data.service";
import { TPR_VSPEERS_PRICE_PERFORMANCE_OPTIONS } from "src/app/tpr/tpr-constants";
import { moveItemInArray } from "@angular/cdk/drag-drop";
import { DeleteDpParams } from "src/app/store/actions/global-subheader.actions";

@Component({
  selector: "app-comparative-tpr",
  templateUrl: "./comparative-tpr.component.html",
  styleUrls: ["./comparative-tpr.component.scss"],
})
export class ComparativeTprComponent {
  @Input() isActive = true;
  @Input() state;
  @Input() shouldFetchData = false;
  @Output() updateTprState: EventEmitter<any> = new EventEmitter();
  @Output() onDataFetchInitiate: EventEmitter<any> = new EventEmitter();
  @Input() routeParams;
  @Input() routeQueryParams;
  @Input() pageType;
  @Input() compType;
  @Input() compId;
  @Input() recentlyVisitedCompanies;
  @Input() watchlistData;
  @Input() industryMenuData;
  @Input() suggestedPeers;
  @Input() tickerModalDataReady;
  @Input() marketGeoData;
  @Input() sortByColumnId;
  @Output() initiateWatchlistFetch: EventEmitter<any> = new EventEmitter();
  @Output() updateUnsavedDataStatus: EventEmitter<any> = new EventEmitter();
  @Output() onFetchLineitemData: EventEmitter<any> = new EventEmitter();
  @Output() updateGridSortByColumnId: EventEmitter<any> = new EventEmitter();

  tickers;
  currency;
  pricePerformance;

  currentTabId = "peer";
  columnPickerAvailableColumns: Array<any> = [];
  columnPickerSelectedColumns: Array<any> = [];
  meta: any;
  _meta: any;
  columnPickerData = [];
  tprVsPeersColumnPickerItem = [];
  marketDataCopyRightMessage = MARKETDATA_COPYRIGHT_MESSAGE;
  tabType = TAB_BE_MAPPING.tpr;
  apiEP: string = window.apiUrl;
  pricePerformanceAvailable = false;
  originallySelectedColumnsPickerData = [];
  isColumnPickerModalVisible = false;
  tickerLimit = 500;
  tickersModal: NzModalRef;
  storeDataKey = "watchlist";
  pricePerformanceOptions = [...TPR_VSPEERS_PRICE_PERFORMANCE_OPTIONS];
  gridSortByColumnId;

  //excel export
  excelToExportDropdownOptions = [
    {
      label: "Values",
      id: 1,
      disabled: false,
    },
    {
      label: "Excel Add-In Formulas",
      id: 0,
      disabled: true,
    },
  ];
  isExportPopoverVisible = false;
  isExportInProgress = false;
  sortedTickers;

  //snackbar
  snackBarRef: MatSnackBarRef<any>;
  snackbarMessage = "";

  snackbarInfo: { message: string; type: string } = {
    message: "",
    type: "info",
  };

  //icons
  faTimes = faTimes;
  faCheck = faCheck;
  faTimesCircle = faTimesCircle;
  faInfoCircle = faInfoCircle;

  // instance variables
  shouldFetchMeta;
  headerTitle: string = "";

  // loaders
  isMetaInProgress = true;
  isDataInProgress = true;
  isMetaReady = false;
  isUserSettingUpdateInProgress = false;

  //subscribers
  globalAppSettingSubscriber: Subscription;
  currencyMessageSubscriber: Subscription;

  constructor(
    private dataService: ComparativeAnalysisService,
    private store: Store<AppState>,
    private tprDataService: TPRDataService,
    private snackBar: MatSnackBar,
    private modalService: NzModalService,
    private watchlistDataService: WatchlistService,
    private compsDataService: CompsDataService,
  ) {}

  @ViewChild("successTemplate") successTemplate: TemplateRef<any>;
  @ViewChild("failureTemplate") failureTemplate: TemplateRef<any>;
  @ViewChild("infoTemplate") infoTemplate: TemplateRef<any>;

  ngOnInit() {
    this.globalAppSettingSubscriber = this.store
      .select(
        stateGetter("globalHeader", "globalAppSettings", "period_settings"),
      )
      .subscribe((data) => {
        if (data) {
          //raise update of common state to trigger data calls on all tabs
          if (!this.isMetaInProgress && this.state && this.isActive) {
            this.updatevsPeerTabData(this.state);
          }
        }
      });
  }

  ngOnChanges(changes) {
    if (
      changes.state &&
      changes.state.currentValue &&
      changes.state.currentValue !== changes.state.previusValue
    ) {
      this.tickers = this.state.tickers;
      this.headerTitle = this.state.headerTitle;
      this.currency = this.state.currency;
    }

    if (
      (changes.routeParams &&
        changes.routeParams.currentValue &&
        changes.routeParams.currentValue !==
          changes.routeParams.previousValue) ||
      (changes.routeQueryParams &&
        changes.routeQueryParams.currentValue &&
        changes.routeQueryParams.currentValue !==
          changes.routeQueryParams.previousValue)
    ) {
      this.shouldFetchMeta = true;
    }

    if (
      changes.sortByColumnId &&
      changes.sortByColumnId.currentValue !==
        changes.sortByColumnId.previousValue
    ) {
      this.gridSortByColumnId = this.sortByColumnId;
    }

    if (
      changes.isActive &&
      changes.isActive.currentValue &&
      !changes.isActive.previousValue
    ) {
      if (
        this.shouldFetchMeta ||
        changes.isActive.firstChange ||
        this.shouldFetchData
      ) {
        const isUserPageType = this.checkIfUserPageType();
        const metaPayload = isUserPageType
          ? getMetaPayloadFromUrls(
              this.routeParams,
              this.routeQueryParams,
              this.tabType,
              this.compType,
            )
          : getMetaPayloadFromUrls(
              this.routeParams,
              this.routeQueryParams,
              this.tabType,
              this.compType,
              this.state,
            );
        this.fetchAndUpdateComparativeMeta(metaPayload, true);
        this.shouldFetchMeta = false;
      }
    }
  }

  /**
   * Set the snackbar message and snackbarRef
   */
  showSnackBarToastMessage(info) {
    this.snackbarMessage = info.message;
    this.snackBarRef = this.getSnackbarRef(info.type);
  }

  /**
   * Hides the snack bar
   */
  dismissSnackBar() {
    if (this.snackBarRef) {
      this.snackBarRef.dismiss();
    }
  }

  /**
   * Shows snackbar message, according to (success | info | failure) template
   * @param {object} type - type of message (success | info | failure)
   */
  getSnackbarRef(type) {
    const typeMap = {
      success: this.successTemplate,
      info: this.infoTemplate,
      failure: this.failureTemplate,
    };
    if (typeMap[type]) {
      return this.snackBar.openFromTemplate(typeMap[type], {
        panelClass: type,
        duration: 5000,
        verticalPosition: "top",
      });
    }
    return undefined;
  }

  updatevsPeerTabData(obj) {
    this.state = {
      ...this.state,
      ...obj,
    };
  }

  checkIfUserPageType() {
    return this.pageType === "user";
  }

  fetchAndUpdateComparativeMeta(metaPayload, firstCall = false) {
    this.shouldFetchMeta = false;
    this.isMetaInProgress = true;
    this.store.dispatch(new DeleteDpParams());
    this.dataService
      .fetchComparativeAnalysisMeta(metaPayload)
      .subscribe(
        (response: { data: any; status: string; status_code?: number }) => {
          if (response && response.status === "success" && response.data) {
            this._meta = {
              columns: response.data.columns,
              colInfo: response.data.col_info,
              tickerInfo: response.data.ticker_info,
              apiTypeList: response.data.api_type_list,
              currency: response.data.currency,
            };
            this.columnPickerSelectedColumns =
              response.data.column_picker_selected_columns;
            this.columnPickerAvailableColumns =
              response.data.column_picker_all_columns;
            this.settingAvailableColumnsForColumnPicker(
              this.columnPickerAvailableColumns,
            );
            this.settingColumnPickerData(this.columnPickerSelectedColumns);

            this.isMetaInProgress = false;
            this.isMetaReady = true;
            const formattedTickerInfo = response.data.ticker_info.map(
              (item) => {
                return {
                  ...item,
                  full_name: item.name || item.full_name,
                };
              },
            );
            this.createvsPeerTab(response.data, formattedTickerInfo, firstCall);
            this.setMetaValues();
            this.onDataFetchInitiate.emit();
          }
        },
      );
  }

  setMetaValues() {
    this.meta = this._meta;
  }

  createvsPeerTab(metaData: any, updatedTickerInfo, firstCall) {
    this.tickers = updatedTickerInfo;
    this.currency = metaData.currency;
    this.pricePerformance = metaData.price_performance;
    this.headerTitle = metaData.comps_name;
    this.columnPickerSelectedColumns = metaData.column_picker_selected_columns;

    const state = {
      tickers: updatedTickerInfo,
      currency: metaData.currency,
      pricePerformance: metaData.price_performance,
      headerTitle: metaData.comps_name,
      columnPickerSelectedColumns: metaData.column_picker_selected_columns,
      loadingWithMeta: firstCall,
    };
    this.updatevsPeerTabData(state);
    this.updateTprState.emit(state);
  }

  settingAvailableColumnsForColumnPicker(arrayOfColumns) {
    this.tprVsPeersColumnPickerItem = [];
    for (let k = 0; k < arrayOfColumns.length; k++) {
      let obj = {
        id: arrayOfColumns[k],
        name: arrayOfColumns[k],
        isSelected: true,
        isDisabled: false,
        isDraggable: true,
        isRemovable: true,
        index: k,
      };
      if (
        arrayOfColumns[k] === "Ticker" ||
        arrayOfColumns[k] === "Company Name" ||
        arrayOfColumns[k] === "Market Cap" ||
        arrayOfColumns[k] === "Enterprise value"
      ) {
        obj = {
          ...obj,
          isDraggable: false,
          isRemovable: false,
        };
      }
      this.tprVsPeersColumnPickerItem.push(obj);
    }
    this.columnPickerData = this.tprVsPeersColumnPickerItem;
  }

  updateTickerOrder(tickerOrderedList) {
    this.sortedTickers = tickerOrderedList;
  }

  handleETEListItemClick(exportType) {
    this.isExportInProgress = true;
    const ticker = this.tickers[0].ticker;
    const templateType = "tpr vs peers";
    const tprGridType = true;
    const params = `export_type=${exportType}&template_type=${templateType}&tab=peer&tpr_grid_type=${tprGridType}&ticker=${ticker}`;

    const tickerCids = this.sortedTickers.map((item) => {
      return item.cid;
    });

    const state = {
      tickers: this.tickers,
      currency: this.currency,
      pricePerformance: this.pricePerformance,
      columnPickerSelectedColumns: this.columnPickerSelectedColumns,
    };
    const tprDetails = createTPRTabUserSettings(state, tickerCids);

    const payload = {
      ...tprDetails,
      tab_type: this.tabType,
      comp_type: this.compType,
      comps_name: this.headerTitle,
    };

    this.dataService.downloadComparativeTPRExport(payload, params).subscribe(
      (res) => {
        if (res["status"] === "success") {
          this.isExportInProgress = false;
        } else {
          this.isExportInProgress = false;
          this.snackbarInfo.message =
            "TPR vs Peers export couldn't be downloaded.";
          this.snackbarInfo.type = "failure";
        }
        this.isExportPopoverVisible = false;
      },
      (err) => {
        this.isExportInProgress = false;
        console.error(err);
      },
    );
  }

  editTickers() {
    this.tickersModal = this.modalService.create({
      nzTitle: "Edit Tickers",
      nzContent: ComparativeTickerModalComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        addRowTableData: this.tickers, //this.addRowTableData,
        suggestedPeers: {
          watchername: "Suggested Peers",
          company_info: this.suggestedPeers,
        },
        recentlyVisitedCompanies: {
          company_info: this.recentlyVisitedCompanies
            ? [...this.recentlyVisitedCompanies]
            : [],
          watchername: "Recently viewed (up to 30)",
        },
        industryData: this.industryMenuData ? [...this.industryMenuData] : [],
        watchlistData: this.watchlistData ? [...this.watchlistData] : [],
        watchlistName: this.headerTitle,
        marketGeoData: this.marketGeoData
          ? { ...this.marketGeoData }
          : undefined,
        maxHeight: "340px",
        mpt: 1, //this.mpt,
        type: "edit",
        maxTickers: this.tickerLimit,
      },
      nzWrapClassName: "comps-modal-container vertical-center-modal",
      // nzWrapClassName: "watchlist-modal-container search-and-add-modal-container",
      nzFooter: [
        {
          label: "Cancel",
          type: "default",
          onClick: (): void => {
            this.tickersModal.destroy();
          },
        },
        {
          label: "Update",
          type: "primary",
          class: "update-btn",
          onClick: (data): void => {
            this.updateTickers(data);
          },
          disabled: (data) => {
            return (
              data["watchlistError"] !== "" ||
              data["modalData"].length > this.tickerLimit ||
              data["modalData"].length === 0
            );
          },
        },
      ],
    });
  }

  saveWatchlist(watchistError, modalData, watchlistName) {
    const tickerList = modalData.map((item) => {
      return item.ticker;
    });
    if (
      watchistError === "" &&
      watchlistName &&
      watchlistName.length > 0 &&
      tickerList.length > 0
    ) {
      const jsonData = {
        watchername: watchlistName,
        tickerlist: tickerList,
      };
      // this.isLoadingSaveWatchlist = true;
      let watchlistId = "";
      this.watchlistDataService.saveWatchlist(jsonData).subscribe(
        (response) => {
          if (response.status === "success") {
            watchlistId = response.watchlistid.toString();
            this.addWatchlistStore(watchlistId, watchlistName);
            this.initiateWatchlistFetch.emit();
          }
          this.snackbarInfo.message = `${watchlistName} saved as a new watchlist`;
          this.snackbarInfo.type = "info";
          this.showSnackBarToastMessage(this.snackbarInfo);
        },
        (error) => {
          // this.isLoadingSaveWatchlist = false;
          console.error(error);
        },
      );
    }
  }

  addWatchlistStore(watchlistId, watchlistName) {
    const payload = {
      respData: {
        watchlistId: Number(watchlistId),
        label: watchlistName,
      },
      key: this.storeDataKey,
    };
    this.store.dispatch(new AddWatchlistData(payload));
  }

  updateTickers(data) {
    const { modalData, watchlistName, watchlistError } = data;
    this.tickersModal.destroy();

    // FOR SAVING WATCHLIST
    if (data.saveWatchlist) {
      this.saveWatchlist(watchlistError, modalData, watchlistName);
    }
    const tickerId = [];
    const companyId = [];
    for (const item of modalData) {
      tickerId.push(item.ticker);
      companyId.push(item.company_id || item.cid);
    }
    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const tickerToUpdate = {
        Ticker: {
          cids: companyId,
        },
      };
      const settingsPayload = updateCustomTableSettingsForTickers(
        this.compId,
        TAB_BE_MAPPING.tpr,
        tickerToUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.tickers = modalData;
            const tickerstate = { tickers: modalData };
            this.updateTprState.emit(tickerstate);
            this.updatevsPeerTabData(tickerstate);

            const metaPayload = getMetaPayloadFromUrls(
              this.routeParams,
              this.routeQueryParams,
              this.tabType,
              this.compType,
            );
            this.fetchAndUpdateComparativeMeta(metaPayload);
            this.onFetchLineitemData.emit({
              tickers: tickerId,
              showSuggestedLineItems: true,
              currency: this.currency,
            });
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      this.tickers = modalData;
      const tickerstate = { tickers: modalData };
      this.updateTprState.emit(tickerstate);
      this.updateGridSortByColumnId.emit();
      this.updatevsPeerTabData(tickerstate);
      const metaPayload = getMetaPayloadFromUrls(
        this.routeParams,
        this.routeQueryParams,
        this.tabType,
        this.compType,
        this.state,
      );
      this.fetchAndUpdateComparativeMeta(metaPayload);
      this.updateUnsavedDataStatus.emit();
      this.onFetchLineitemData.emit({
        tickers: tickerId,
        showSuggestedLineItems: true,
        currency: this.currency,
      });
    }
  }

  onSearchTickerSelection(tickerData) {
    const { value } = tickerData;
    let checIfTickerExist = false;
    for (const item of this.tickers) {
      if (item.ticker === value.ticker) {
        checIfTickerExist = true;
        // this.snackbarInfo.message = "This ticker is already present.";
        //   this.snackbarInfo.type = "info";
        //   this.showSnackBarToastMessage(this.snackbarInfo);
        this.snackbarMessage = "This ticker is already present.";
        this.snackBarRef = this.snackBar.openFromTemplate(this.infoTemplate, {
          panelClass: "info",
          duration: 5000,
          verticalPosition: "top",
        });
      }
    }
    if (!checIfTickerExist && this.tickers.length <= this.tickerLimit) {
      this.updateSearchedTicker(tickerData);
    }
  }

  updateSearchedTicker(selectedTicker) {
    const tickerObj = {
      full_name: selectedTicker.value.name || selectedTicker.value.full_name,
      name: selectedTicker.value.name || selectedTicker.value.full_name,
      ticker: selectedTicker.value.ticker,
      company_id: selectedTicker.value.cid,
    };
    const allTickers = this.tickers.concat(tickerObj);
    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const tickerToUpdate = {
        Ticker: {
          cids: allTickers.map(
            (item) => item.company_id || item.cid || item.companyid,
          ),
        },
      };
      const settingsPayload = updateCustomTableSettingsForTickers(
        this.compId,
        TAB_BE_MAPPING.tpr,
        tickerToUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.tickers = allTickers;
            const tickerstate = { tickers: allTickers };
            this.updateTprState.emit(tickerstate);
            this.updatevsPeerTabData(tickerstate);
            const metaPayload = getMetaPayloadFromUrls(
              this.routeParams,
              this.routeQueryParams,
              this.tabType,
              this.compType,
            );
            this.fetchAndUpdateComparativeMeta(metaPayload);
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      this.tickers = allTickers;
      const tickerstate = { tickers: allTickers };
      this.updateTprState.emit(tickerstate);
      this.updateGridSortByColumnId.emit();
      this.updatevsPeerTabData(tickerstate);
      const metaPayload = getMetaPayloadFromUrls(
        this.routeParams,
        this.routeQueryParams,
        this.tabType,
        this.compType,
        this.state,
      );
      this.fetchAndUpdateComparativeMeta(metaPayload);
      this.updateUnsavedDataStatus.emit();
    }
    this.snackbarInfo.message = `${selectedTicker.value.ticker} has been added to the Table.`;
    this.snackbarInfo.type = "success";
    this.showSnackBarToastMessage(this.snackbarInfo);
  }

  /**
   * Executes on selection of currency
   * It stores currency
   * @param {object} item - selected currency
   */
  handleCurrencyChange(item) {
    if (!item) {
      return;
    }

    const isUserPageType = this.checkIfUserPageType();

    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const currencyToUpdate = {
        Currency: {
          currency_iso: item,
        },
      };
      const settingsPayload = updateCustomTableSettings(
        this.compId,
        TAB_BE_MAPPING.tpr,
        currencyToUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.currency = item;
            const currencyState = {
              currency: item,
            };
            this.updateTprState.emit(currencyState);
            this.updatevsPeerTabData(currencyState);

            const metaPayload = getMetaPayloadFromUrls(
              this.routeParams,
              this.routeQueryParams,
              this.tabType,
              this.compType,
            );
            this.fetchAndUpdateComparativeMeta(metaPayload);
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      const currencyState = {
        currency: item,
      };
      this.updateTprState.emit(currencyState);
      this.updatevsPeerTabData(currencyState);
      const metaPayload = getMetaPayloadFromUrls(
        this.routeParams,
        this.routeQueryParams,
        this.tabType,
        this.compType,
        this.state,
      );
      this.fetchAndUpdateComparativeMeta(metaPayload);
      this.updateUnsavedDataStatus.emit();
    }
  }

  handlePricePerformanceChange(value) {
    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const lineitemToUpdate = {
        LineItem: {
          tpr_grid_columns: this.columnPickerSelectedColumns,
          price_performance: value,
        },
      };
      const settingsPayload = updateCustomTableSettings(
        this.compId,
        TAB_BE_MAPPING.tpr,
        lineitemToUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.pricePerformance = value;
            const pricePerformanceState = {
              pricePerformance: value,
            };
            this.updateTprState.emit(pricePerformanceState);
            this.updatevsPeerTabData(pricePerformanceState);
            const metaPayload = getMetaPayloadFromUrls(
              this.routeParams,
              this.routeQueryParams,
              this.tabType,
              this.compType,
            );
            this.fetchAndUpdateComparativeMeta(metaPayload);
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      this.pricePerformance = value;
      const pricePerformanceState = {
        pricePerformance: value,
      };
      this.updateTprState.emit(pricePerformanceState);
      this.updatevsPeerTabData(pricePerformanceState);
      const metaPayload = getMetaPayloadFromUrls(
        this.routeParams,
        this.routeQueryParams,
        this.tabType,
        this.compType,
        this.state,
      );
      this.fetchAndUpdateComparativeMeta(metaPayload);
      this.updateUnsavedDataStatus.emit();
    }
  }

  // Column Picker
  hanldeColumnPickerClick() {
    this.isColumnPickerModalVisible = !this.isColumnPickerModalVisible;
  }

  handleColumnPickerResetClick() {
    this.columnPickerData = [...this.tprVsPeersColumnPickerItem];
  }

  handleColumnPickerCancelClick() {
    this.columnPickerData = [...this.originallySelectedColumnsPickerData];
    this.isColumnPickerModalVisible = false;
  }

  handleColumnDrag(data) {
    const selectedItems = data.componentState.selectedItems;
    // There are four fixed column, so currentIndex of dragged items should be more than 3
    if (data.event.currentIndex > 3) {
      moveItemInArray(
        selectedItems,
        data.event.previousIndex,
        data.event.currentIndex,
      );
      this.columnPickerData = this.columnPickerData.map((column) => {
        const index = selectedItems.findIndex(
          (sColumn) => sColumn.id === column.id,
        );
        column.index = index;
        // This component is now aware if some new column was selected/deselected in the modal
        // it would have come to know only on click of apply button. But, now it has to feed in
        // new array of columns, so it should update the selection as well.
        column.isSelected = index !== -1;
        return column;
      });
    }
  }

  settingColumnPickerData(selectedArr) {
    const selectedGridColumns = selectedArr || this.tprVsPeersColumnPickerItem;
    this.pricePerformanceAvailable = selectedArr.includes("Price Performance");
    const columnPickerData = updateColumnPickerData(
      this.columnPickerData,
      selectedGridColumns,
    );
    this.columnPickerData = [...columnPickerData];
    this.originallySelectedColumnsPickerData = [...columnPickerData];
  }

  hanldeColumnPickerApplyClick(value) {
    const selectedItems =
      value && value.selectedItems ? value.selectedItems : [];

    const selectedColumns = getSelectedColumnPickerItemName(selectedItems);
    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const lineitemToUpdate = {
        LineItem: {
          tpr_grid_columns: selectedColumns,
          price_performance: this.pricePerformance,
        },
      };
      const settingsPayload = updateCustomTableSettings(
        this.compId,
        TAB_BE_MAPPING.tpr,
        lineitemToUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.columnPickerSelectedColumns = selectedColumns;
            const seletedColumnsState = {
              columnPickerSelectedColumns: selectedColumns,
            };
            this.updateTprState.emit(seletedColumnsState);
            this.updatevsPeerTabData(seletedColumnsState);
            const metaPayload = getMetaPayloadFromUrls(
              this.routeParams,
              this.routeQueryParams,
              this.tabType,
              this.compType,
            );
            this.fetchAndUpdateComparativeMeta(metaPayload);
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      this.columnPickerSelectedColumns = selectedColumns;
      const seletedColumnsState = {
        columnPickerSelectedColumns: selectedColumns,
      };
      this.updateTprState.emit(seletedColumnsState);
      this.updatevsPeerTabData(seletedColumnsState);
      const metaPayload = getMetaPayloadFromUrls(
        this.routeParams,
        this.routeQueryParams,
        this.tabType,
        this.compType,
        this.state,
      );
      this.fetchAndUpdateComparativeMeta(metaPayload);
      this.updateUnsavedDataStatus.emit();
    }
    this.handleColumnPickerCancelClick();
  }

  getSortByColumnId() {
    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.gridSortByColumnId = "";
    } else if (this.gridSortByColumnId !== "") {
      this.gridSortByColumnId = "C2";
    }
    return this.gridSortByColumnId;
  }
}
